import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'itc-mobile-app-links',
  templateUrl: 'mobile-app-links.component.html',
  styleUrl: 'mobile-app-links.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, TranslatePipe],
})
export class MobileAppLinksComponent {
  readonly appStoreApplicationLink = 'https://apps.apple.com/us/app/kaseya-one/id6466401361';
  readonly googlePlayApplicationLink = 'https://play.google.com/store/apps/details?id=com.kaseya.one';
}
